import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const Pricing = ({ pricing }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleSection = () => {
        setIsExpanded(!isExpanded);
    };
    const AmountRow = ({ amountLabel, amountValue }) => {
        const formattedAmountValue = amountValue ? `${amountValue}` : '-';
        return (
            <div className="flex justify-between py-1">
                <span className="text-sm">{amountLabel}</span>
                <span className="text-sm font-medium">{formattedAmountValue}</span>
            </div>
        );
    };
    const Divider = () => <div className="h-px bg-gray-300 my-2" />;
    return (
        <div className="pt-5 pb-2">
            <h2 className="text-lg font-semibold">Package Pricing</h2>

            <div className="flex justify-between items-center mt-2 bg-gray-100 rounded-md p-3">
                <div className="w-5/6">
                    <p className="text-lg font-medium truncate">
                        ₹ {pricing?.finalAmount}.00
                    </p>
                    <p className="text-xs text-gray-600">
                        Includes tax and convenience charges.
                    </p>
                </div>

                <button
                    className="w-10 h-10 flex items-center justify-center bg-gray-200 rounded-full"
                    onClick={toggleSection}
                >
                    {isExpanded ? (
                        <FaChevronUp className="text-gray-700 text-xl" />
                    ) : (
                        <FaChevronDown className="text-gray-700 text-xl" />
                    )}
                </button>
            </div>

            {isExpanded && (
                 <div className="mt-2">
                 {pricing?.baseAmount && <AmountRow amountLabel={pricing?.baseAmount?.key} amountValue={pricing?.baseAmount?.value} />}
                 {pricing?.discount?.value > 0 && <AmountRow amountLabel={`${pricing?.discount?.key} - ${pricing?.discount?.config?.reason}`} amountValue={pricing?.discount?.value} />}
                 {pricing?.tax?.isIGST?.value ? (
                     pricing?.tax?.igst && <AmountRow amountLabel={pricing?.tax?.igst?.key} amountValue={pricing?.tax?.igst?.value} />
                 ) : (
                     <>
                         {pricing?.tax?.cgst && <AmountRow amountLabel={pricing?.tax?.cgst?.key} amountValue={pricing?.tax?.cgst?.value} />}
                         {pricing?.tax?.sgst && <AmountRow amountLabel={pricing?.tax?.sgst?.key} amountValue={pricing?.tax?.sgst?.value} />}
                     </>
                 )}
                 <Divider />
                 {pricing?.priceAfterTax && <AmountRow amountLabel={pricing?.priceAfterTax?.key} amountValue={pricing?.priceAfterTax?.value} />}
                 {pricing?.platformFee?.originalFee && <AmountRow amountLabel={pricing?.platformFee?.originalFee?.key} amountValue={pricing?.platformFee?.originalFee?.value} />}
                 {pricing?.platformFee?.discount && <AmountRow amountLabel={pricing?.platformFee?.discount?.key} amountValue={pricing?.platformFee?.discount?.value} />}
                 {pricing?.platformFee?.tax?.igst && <AmountRow amountLabel={pricing?.platformFee?.tax?.igst?.key} amountValue={pricing?.platformFee?.tax?.igst?.value} />}
                 {pricing?.platformFee?.tax?.cgst && <AmountRow amountLabel={pricing?.platformFee?.tax?.cgst?.key} amountValue={pricing?.platformFee?.tax?.cgst?.value} />}
                 {pricing?.platformFee?.tax?.sgst && <AmountRow amountLabel={pricing?.platformFee?.tax?.sgst?.key} amountValue={pricing?.platformFee?.tax?.sgst?.value} />}
                 <Divider />
                 {pricing?.finalAmount2 && (
                     <div className="flex justify-between text-lg font-bold">
                         <span>{pricing?.finalAmount2?.key}</span>
                         <span>₹ {pricing?.finalAmount2?.value}</span>
                     </div>
                 )}
                 {pricing?.finalText && <p className="text-center text-xs mt-2">{pricing?.finalText}</p>}
             </div>
            )}
        </div>
    );
};

export default Pricing;
